var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 6H32.72l-.86-2.58A5 5 0 0 0 27.12 0h-6.24a5 5 0 0 0-4.74 3.42L15.28 6H4v2h3l1.62 31.45a9 9 0 0 0 9 8.55h12.77a9 9 0 0 0 9-8.55L41 8h3V6ZM18 4.05A3 3 0 0 1 20.88 2h6.23A3 3 0 0 1 30 4.05L30.61 6H17.39Zm19.34 35.3a7 7 0 0 1-7 6.65H17.61a7 7 0 0 1-7-6.65L9.05 8h29.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.501 15.048 1.998-.09 1 21.997-1.999.09zM27.5 36.953l1-21.998 1.997.091-.999 21.997z"
  })));
};
export default SvgTrash;